import axios from 'axios';
import { URL_API } from '../config';
import { get } from '../httpmethods';

export const VideoAPI = {
    getPublisherToken: async (guid) => {
        return await get(`${URL_API}/video/token/${guid}`);
    },

    getAdminToken: async (guid) => {
        return await get(`${URL_API}/admin/video/token/${guid}`);
    },

    getPublicToken: async (guid) => {
        try {
            const { data } = await axios.get(`${URL_API}/public/video/token/${guid}`);
            return { data, success: true };
        } catch (error) {
            return {
                success: false,
                message:
                    error.response?.data?.message ||
                    error.message ||
                    'Não foi possível obter acesso à transmissão'
            };
        }
    }
};
